import { useState, useContext, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { AuthContext } from "../../../../../shared/context/auth-context";
import { ClinicaContext } from "../../../../../shared/context/clinica-context";

import OrcamentosComponent from "../OrcamentosComponent/OrcamentosComponent";
import AvaliacoesComponent from "../AvaliacoesComponent/AvaliacoesComponent";
import PlanosTratamentoComponent from "../PlanosTratamentoComponent/PlanosTratamentoComponent";
import "./FluxoAtendimento.scss";
import TratamentoIsoladosComponent from "../TratamentoIsoladosComponent/TratamentoIsoladosComponent";

function FluxoAtendimento({ clienteId, sendRequest, dadosOrcamento }) {
  const [showTabs, setShowTabs] = useState("");
  const auth = useContext(AuthContext);
  const clinica = useContext(ClinicaContext);
  const navigate = useNavigate();

  const temporary = useParams().clienteId;
  const abaAberta = temporary.split("-")[1];

  useEffect(() => {
    if (abaAberta) {
      if (abaAberta === "avaliacao" && auth.perm.includes("r-aval"))
        setShowTabs("avaliacao");
      else if (abaAberta === "planotratamento" && auth.perm.includes("r-plt"))
        setShowTabs("planotratamento");
      else if (abaAberta === "orcamento" && auth.perm.includes("r-orc"))
        setShowTabs("orcamento");
      else if (
        abaAberta === "tratamentoIsolado" &&
        auth.perm.includes("r-consult")
      )
        setShowTabs("tratamentoIsolado");
    } else setShowTabs("avaliacao");
  }, [abaAberta]);

  const [modalTratamentoIsoladoOpen, setModalTratamentoIsoladoOpen] =
    useState(false);

  const handleCloseModalTratamentoIsolado = () => {
    setModalTratamentoIsoladoOpen(false);
  };

  // Estado próprio, para os dois modais nunca se confundirem um com o outro.
  const [modalImportarHistoricoOpen, setModalImportarHistoricoOpen] =
    useState(false);

  const handleCloseModalImportarHistorico = () => {
    setModalImportarHistoricoOpen(false);
  };

  return (
    <div className="singleContainer__fluxo-atendimento caixa">
      <div className="singleContainer__fluxo-atendimento-tabs">
        {auth.perm.includes("r-aval") && (
          <span
            className={`tab-button ${
              showTabs === "avaliacao" && "tab-button--active"
            }`}
            onClick={() => setShowTabs("avaliacao")}
          >
            Avaliações
          </span>
        )}

        {auth.perm.includes("r-orc") && (
          <span
            className={`tab-button ${
              showTabs === "orcamento" && "tab-button--active"
            }`}
            onClick={() => setShowTabs("orcamento")}
          >
            Orçamentos
          </span>
        )}

        {auth.perm.includes("r-plt") && (
          <span
            className={`tab-button ${
              showTabs === "planotratamento" && "tab-button--active"
            }`}
            onClick={() => setShowTabs("planotratamento")}
          >
            Planos Tratamento
          </span>
        )}

        {auth.perm.includes("r-consult") && (
          <span
            className={`tab-button ${
              showTabs === "tratamentoIsolado" && "tab-button--active"
            }`}
            onClick={() => setShowTabs("tratamentoIsolado")}
          >
            Tratamentos Isolados
          </span>
        )}
      </div>

      <div className="singleContainer__fluxo-atendimento-tabs--Container">
        <div className="tabs-container-top">
          {showTabs === "avaliacao" &&
            // !avaliacoesEmAndamentoOuCriadas &&
            auth.perm.includes("c-aval") &&
            (auth.role === "Dentista" ||
              auth.role === "Médico/Administrador" ||
              auth.role === "Secretária(o)" ||
              auth.role === "Assistente") && (
              <span
                className="tabs-container-top-button"
                onClick={() => navigate(`../../../avaliacao/new/${clienteId}`)}
              >
                Criar Avaliação
              </span>
            )}

          {showTabs === "orcamento" &&
            // !avaliacoesEmAndamentoOuCriadas &&
            auth.perm.includes("c-orc") &&
            (auth.role === "Dentista" ||
              auth.role === "Médico/Administrador" ||
              auth.role === "Secretária(o)" ||
              auth.role === "Assistente") && (
              <span
                className="tabs-container-top-button"
                onClick={() =>
                  navigate(`/clientes/${clienteId}/orcamentoDireto/novo`)
                }
              >
                Criar Orçamento Direto
              </span>
            )}

          {showTabs === "tratamentoIsolado" &&
            // auth.perm.includes("c-aval") &&
            (auth.role === "Dentista" ||
              auth.role === "Médico/Administrador") && (
              <span
                className="tabs-container-top-button"
                onClick={() => setModalTratamentoIsoladoOpen(true)}
              >
                Criar Tratamento Isolado
              </span>
            )}

          {/* Segundo botão, e não uma alternativa ao de cima: a criação normal
              fica exatamente como está. Só aparece com «Importação de
              Histórico» ligada em Configurações → Outras, e nas clínicas que a
              tenham desligada esta aba não muda nada. */}
          {showTabs === "tratamentoIsolado" &&
            (auth.role === "Dentista" ||
              auth.role === "Médico/Administrador" ||
              /* A secretária só quando a clínica o permitir — o servidor
                 verifica a mesma condição. */
              (auth.role === "Secretária(o)" &&
                clinica?.clinica?.configuracoes?.configuracoes
                  ?.importacaoHistorico?.secretariaPode === true)) &&
            clinica?.clinica?.configuracoes?.configuracoes?.importacaoHistorico
              ?.ativo === true && (
              <span
                className="tabs-container-top-button"
                onClick={() => setModalImportarHistoricoOpen(true)}
              >
                Importar Histórico
              </span>
            )}
        </div>

        <div className="tabs-container-content">
          {showTabs === "avaliacao" && auth.perm.includes("r-aval") && (
            <AvaliacoesComponent
              clienteId={clienteId}
              sendRequest={sendRequest}
              token={auth.token}
            />
          )}
          {showTabs === "planotratamento" && auth.perm.includes("r-plt") && (
            <PlanosTratamentoComponent
              clienteId={clienteId}
              sendRequest={sendRequest}
              token={auth.token}
            />
          )}
          {showTabs === "orcamento" && auth.perm.includes("r-orc") && (
            <OrcamentosComponent
              dadosOrcamento={dadosOrcamento}
              clienteId={clienteId}
              sendRequest={sendRequest}
              token={auth.token}
            />
          )}
          {showTabs === "tratamentoIsolado" &&
            auth.perm.includes("r-consult") && (
              <TratamentoIsoladosComponent
                clienteId={clienteId}
                sendRequest={sendRequest}
                modalTratamentoIsoladoOpen={modalTratamentoIsoladoOpen}
                handleCloseModalTratamentoIsolado={
                  handleCloseModalTratamentoIsolado
                }
                modalImportarHistoricoOpen={modalImportarHistoricoOpen}
                handleCloseModalImportarHistorico={
                  handleCloseModalImportarHistorico
                }
              />
            )}
        </div>
      </div>
    </div>
  );
}

export default FluxoAtendimento;
